<template>
    <div>
        <PageHeader :linkto="'/Payment/Plan'" :linkttitle="'返回'" title="業務合約"></PageHeader>

        <b-container >



                <hr>
                <h4>軟體經銷合約書</h4>

                <p>立合約書人 永冠數位行銷有限公司(以下簡稱甲方)，旗下專家會員(以下簡稱乙方)</p>

                <p>茲因甲方同意，乙方加入甲方，依甲方之審核並由甲方同意乙方以經銷方式進行公開銷售，雙方就此訂定相關權利義務並簽訂本契約，同意共同遵守下列條款：</p>
                <ul>
                    <li>1.甲方授權乙方經銷之產品標的物：[ 姓名DNA網站] 軟體。</li>
                    <li>2.經銷地區：台灣地區。</li>
                    <li>3.合約有效期間：
                        乙方同意本合約並支付會費起算，至乙方告知終止合約次日，會員資格終止。
                    </li>

                </ul>


                <h5>甲乙雙方之權利義務訂定如下：</h5>
                <ul>


                    <li>甲乙方對上述產品標的物之權利義務：<br>
                        甲乙方負責市場銷售事宜。<br>
                        甲乙方負責客戶售後服務事宜。
                        <br>
                        甲方之責任：<br>
                        甲方保證其所授權乙方之商品，皆享有合法之權利，或具有合法之權源，絕無侵害他人權利之情事。<br>
                        如遇第三人提出權利侵害之主張時，甲方應負所有法律責任與賠償甲方所有損失。<br>
                        如遇消費者購買乙方商品產生的糾紛問題，皆依照消費者保護法規定處理。<br>
                        本經銷權及合約不得私下轉讓，任何轉讓皆需經由甲乙雙方同意。

                    </li>


                    <li>付款方式：<br>
                        雙方同意乙方每銷售一套，應給予乙方佣金，銷售金額30%。<br>
                        業務佣金將於指定每月1日，15日撥款入乙方設定的銀行帳戶。<br>
                        撥款方式：舉例乙方於5日銷售一套，佣金將於當月的15日撥款。<br>
                        舉例乙方於14日銷售一套.佣金將於隔月的1日撥款。<br>

                    </li>
                    <li>稅率：<br>
                        依法於給付時，達稅額扣繳及補充保費扣取金額時，自給付所得人之薪資所得內代扣。<br>
                        兼職薪資扣繳稅率5%，每次給付金額未達薪資所得扣繳稅額表無配偶及受扶養親屬者之起扣標準者 (107至109年度為 84,501元），免予扣繳。<br>
                        兼職薪資補充保費費率1.91%，每次給付金額未達基本工資(109年度為23,800元)，免予扣取。<br>

                    </li>
                    <li>續約<br>
                        乙方同意甲方採定期定額繳款方式自動扣帳，在每年約期到時，自動續約。<br>
                        乙方如要取消續會需合約到期日前ㄧ個月告知甲方，超過一個月告之，乙方需等再下一期續約方能停止續會。<br>
                    </li>
                    <li>會員合約終止<br>
                        乙方如告知甲方在續約期前一個月終止續約，告知次日合約終止。<br>

                    </li>
                    <li>佣金分配案例<br>
                        1.乙方個人推廣一組$3000元台幣，可分潤30%的推廣獎金$900元。乙方銷售一組$5000台幣，可獲取30%的推廣獎金$1500元。<br>
                        2.乙方銷售之客戶，每年如有續年費$1000，乙方可分潤30%（金額$300獎金）<br>


                    </li>

                    <li>訴訟管轄：<br>
                        如遇爭議，雙方同意依甲方所選擇之地方法院為管轄法院，循法律途徑處理之。
                    </li>

                </ul>
                <hr>
                <b-form-checkbox class="mt-3 mb-2 mr-sm-2 mb-sm-0 text-primary" v-model="checkconfirm">
                    我已詳閱上述合約內容，並同意相關條件（點擊進入付款即代表同意合約內容）
                </b-form-checkbox>
                <hr>
                <b-button v-if="payStatus" :disabled="!checkconfirm" size="lg" variant="primary" @click="confirm()">同意，進入付款</b-button>
                <hr>


        </b-container>
    </div>
</template>
<style>

</style>

<script>

import PageHeader from '@/components/PageHeader.vue'
import { mapState } from 'vuex'

import { toastsModel, alertModel } from '@/service/commuse'
import {imageUrl} from '@/config/env';

export default {
  name: 'Contract',
  components: {PageHeader},

  data () {
    return {
      checkconfirm:true,
      payStatus:false
    }
  },
  computed: {
    ...mapState(['shopcart', 'profiledata','orderpurchase']),
    puid:function () {return Object.keys(this.shopcart).length !== 0 ? this.shopcart.product_id : '';},

  },
  created () {

  },
  mounted () {
    if (Object.keys(this.shopcart).length == 0) {
      this.$router.push('/Payment/Plan')
    }else{
      this.appStatus()
    }
  },
  methods: {
    confirm(){

      this.$store.dispatch('actionCheckOut', {Puid:this.orderpurchase.puid,ChoicePay:this.orderpurchase.ChoicePay}).then((res) => {

        document.open();
        document.write(res);
        document.close();

      }).catch((res) => {

      })

    },
    appStatus(){

      this.$store.dispatch('actionGetAppStatus',{})
        .then((res) => {

          this.payStatus = res.data.payment

        })
        .catch((res) => {

        })
    }

  }
}
</script>
